import { DropDownItem } from './base/DropDownItem';
import { cssPrefix } from '../../../../const/Constant';
import { Icon } from './Icon';
import { HorizontalContextMenu } from './contextmenu/horizontal/HorizontalContextMenu';
import { BaseFont } from '../../../../draw/font/BaseFont';

class HorizontalAlign extends DropDownItem {
  constructor(options = { contextMenu: {} }) {
    super(`${cssPrefix}-tools-horizontal-align`);
    this.options = options;
    this.icon = new Icon('align-left');
    this.setIcon(this.icon);
    this.setTitleTips(BaseFont.HORIZONTAL_ALIGN_TEXT.center);
    this.horizontalContextMenu = new HorizontalContextMenu({
      el: this,
      ...this.options.contextMenu,
    }).parentWidget(this);
  }

  destroy() {
    super.destroy();
    this.horizontalContextMenu.destroy();
  }
}
export { HorizontalAlign };
